<template>
  <v-container grid-list-md>
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <h2 class="page-title">
          {{ $t("checklisttemplatecategory." + (checklisttemplatecategory.id ? "edit_title" : "new_title")) }}
        </h2>

        <v-spacer></v-spacer>

        <action-button type="back" @click="$router.go(-1)" />
        <action-button type="save" @click="save" />
        <action-button
          type="delete"
          @click="del(checklisttemplatecategory.id)"
          v-if="checklisttemplatecategory.id && $can('checklisttemplatecategory-delete')"
        />
      </v-app-bar>

      <v-card>
        <v-card-text class="pa-4">
          <v-layout row wrap>
            <v-flex lg3 md4 sm6 xs12>
              <v-autocomplete
                name="category"
                v-model="checklisttemplatecategory.category_id"
                class="required-field"
                item-text="category_name"
                item-value="id"
                :items="equipmentcategories"
                :label="$t('checklisttemplatecategory.category')"
                :error-messages="errors.collect('category')"
                v-validate="'required'"
                autocomplete="new-password"
              ></v-autocomplete>
            </v-flex>

            <v-flex lg3 md4 sm6 xs12>
              <v-autocomplete
                name="name"
                v-model="checklisttemplatecategory.template_id"
                class="required-field"
                item-text="title"
                item-value="id"
                :items="checklisttemplates"
                :label="$t('checklisttemplatecategory.name')"
                :error-messages="errors.collect('name')"
                v-validate="'required'"
                autocomplete="new-password"
              ></v-autocomplete>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "checklisttemplatecategoryForm",
  props: ["id"],
  data() {
    return {
      page_title: "",
      predata: {},
      checklisttemplatecategory: {},

      equipmentcategories: [],
      checklisttemplates: [],

      dictionary: {
        attributes: {
          category: this.$t("checklisttemplatecategory.category"),
          name: this.$t("checklisttemplatecategory.name")
        }
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.checklisttemplatecategory, this.predata, this.save, this.isFormValid)
    })
  },
  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    }
  },
  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },
  created() {
    let lists = [
      {
        key: "checklisttemplates",
        module: "checklisttemplates",
        query: "show_all=true&sort_by=name&sort_order=asc"
      },
      { key: "equipmentcategories", module: "equipmentcategories", query: "" }
    ]

    axios.post(this.API_URL + "request/ddlists", lists).then((res) => {
      this.checklisttemplates = res.data.checklisttemplates
      this.equipmentcategories = res.data.equipmentcategories

      if (!this.id) {
        this.page_title = this.$t("checklisttemplatecategory.new_title")
        this.checklisttemplatecategory = {}
        this.predata = JSON.parse(JSON.stringify(this.checklisttemplatecategory))
      } else {
        axios
          .get(this.API_URL + "checklist-template-category/" + this.id)
          .then((res) => {
            this.checklisttemplatecategory = res.data.data
            this.predata = JSON.parse(JSON.stringify(this.checklisttemplatecategory))

            this.page_title = this.$t("checklisttemplatecategory.edit_title")
          })
          .catch((err) => console.log(err))
      }
    })
  },
  methods: {
    save(close = false) {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this

            if (!this.checklisttemplatecategory.id) {
              // Create
              axios
                .post(this.API_URL + "checklist-template-category", {
                  template_id: this.checklisttemplatecategory.template_id,
                  category_id: this.checklisttemplatecategory.category_id
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.checklisttemplatecategory = res.data.data
                      vm.predata = JSON.parse(JSON.stringify(vm.checklisttemplatecategory))

                      vm.page_title = vm.$t("checklisttemplatecategory.edit_title")

                      vm.$awn.success(vm.$t("global.create_success"))
                      vm.$router.replace(this.BACKEND_URL + `/equipmentchecklist/edit/${vm.checklisttemplatecategory.id}`).catch(() => {})
                    }
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "checklist-template-category", {
                  id: this.checklisttemplatecategory.id,
                  template_id: this.checklisttemplatecategory.template_id,
                  category_id: this.checklisttemplatecategory.category_id
                })
                .then((res) => {
                  vm.checklisttemplatecategory = res.data.data
                  vm.predata = JSON.parse(JSON.stringify(vm.checklisttemplatecategory))

                  vm.page_title = vm.$t("checklisttemplatecategory.edit_title")

                  vm.$awn.success(vm.$t("global.update_success"))
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "checklist-template-category/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/equipmentchecklists")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    }
  }
}
</script>
